import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {FUIAbstractLabel} from "../../../labels/abstract-label";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-filter-label",
    styleUrls: ["./filter-label.component.scss"],
    templateUrl: "./filter-label.component.html",
    standalone: false
})
export class FUIFilterLabelComponent extends FUIAbstractLabel {
}
